module.exports = __webpack_public_path__ + "media/images/desktop/writer-offering-chara01-b071327aeb9df4788af0d42cfd080177.png";